import { fetcher } from '@commenda/utils';
import useSWR from 'swr';
import {
  IContentLibraryIndirectTaxJurisdictionsParams,
  IContentLibraryResponse,
} from './types';

// Hook to fetch indirect tax jurisdictions from Content Library
// Returns jurisdictions in standardized format for Form Builder Select components
export function useContentLibraryIndirectTaxJurisdictions(
  params: IContentLibraryIndirectTaxJurisdictionsParams | null,
  token?: string
) {
  const cacheKey = params
    ? `content-library/indirect-tax-jurisdictions:${params.corporationId}:${params.countries?.join(',') || ''}:${params.states?.join(',') || ''}:${params.types?.join(',') || ''}:${params.search || ''}`
    : null;

  const { data, mutate, error, isLoading } = useSWR<IContentLibraryResponse>(
    cacheKey,
    async () => {
      if (!params) {
        throw new Error('Params required');
      }
      const response = await fetcher(
        'content-library/indirect-tax-jurisdictions',
        { method: 'POST', body: params },
        token
      );
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message ||
            'Failed to fetch jurisdictions from content library'
        );
      }
      return response.json();
    }
  );

  return {
    data,
    mutate,
    error,
    isLoading,
  };
}
